import { useState } from "react";
import { Grid, Box } from "@mui/material";
import HelpSidebar from "../../../../components/HelpSidebar";
import ComingSoon from "../../../../../app/components/ComingSoon";

const ReleaseNotes = () => {

  const sidebarItems = [
    { label: "Release 1.0", subMenus: [], subKey: "May 2026" },
  ];

  const [tab, setTab] = useState(sidebarItems[0].label);

  const renderReleaseNotesDoc = () => {
        return (
            <ComingSoon />
        );
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        bgcolor: "#f5f8fc",
        py: 2,
        height: "calc(100vh - 64px)", // adjust header height if different
        overflow: "hidden",
        minHeight: 0,
      }}
    >
      {/* Sidebar */}
      <Grid item xs={12} md={3} sx={{ height: "100%", minHeight: 0 }}>
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            minHeight: 0,
          }}
        >
          <Box
            sx={{
              overflowY: "auto",
              flex: 1,
              minHeight: 0,
              "&::-webkit-scrollbar": { width: "4px" }, // thinner scrollbar
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.3)",
                borderRadius: "10px",
              },
              scrollbarWidth: "thin",
              scrollbarGutter: "stable",
            }}
          >
            <HelpSidebar sidebarItems={sidebarItems || []} tab={tab} setTab={setTab} />
          </Box>
        </Box>
      </Grid>

      {/* Content */}
      <Grid item xs={12} md={9} sx={{ height: "100%", minHeight: 0 }}>
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            minHeight: 0,
          }}
        >
          <Box
            sx={{
              overflowY: "auto",
              flex: 1,
              minHeight: 0,
              p: 4,
              "&::-webkit-scrollbar": { width: "4px" }, // thinner scrollbar
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.3)",
                borderRadius: "10px",
              },
              scrollbarWidth: "thin",
            }}
          >
            {renderReleaseNotesDoc()}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ReleaseNotes;
